export interface SagePosting {
  id: string;
  postingType: string;
  customer: string;
  supplier: string;
  nominalCode: string;
  ref: string;
  documentDate: string;
  documentNumber: string;
  description: string;
  totalValue: string;
  taxKey: string;
  taxValue: string;
  taxRate: string;
  exchangeRate: string;
  extraReference: string;
  paymentTerms: string;
  accountsRef: string;
  customerName: string;
  supplierName: string;
  paymentDueDate: string;
}
